import { TextComponent } from '@manifest-cyber/design-system/lib/components/TextComponent';
import styles from './RequiredAsterisk.module.scss';

export const RequiredAsterisk = () => (
  <TextComponent variant="bodySmall" className={styles.asterisk}>
    *
  </TextComponent>
);
